import emptyFieldValidate from "@validators/shared/empty.validate";
import { textLength } from "@validators/shared/textLength.validate";
import urlFieldValidate from "@validators/shared/url.validate";

export type TErrors = {
  title: string | undefined;
  date: string | undefined;
  thumbnailUrl: string | undefined;
  mediaUrl: string | undefined;
};

const webinarValidate = (FormValues: Record<string, any>) => {
  let errors: TErrors = {
    title: undefined,
    date: undefined,
    thumbnailUrl: undefined,
    mediaUrl: undefined,
  };

  errors.title = textLength(FormValues.title, "Title", 100, 4);
  errors.date = emptyFieldValidate(FormValues.date, "Date");
  errors.thumbnailUrl = emptyFieldValidate(
    FormValues.thumbnailUrl,
    "Thumbnail"
  );
  errors.mediaUrl =
    typeof FormValues.mediaUrl === "string"
      ? urlFieldValidate(FormValues.mediaUrl, "Media")
      : emptyFieldValidate(FormValues.mediaUrl, "Media");

  return errors;
};

export default webinarValidate;
